import { TIME_RANGES } from "@/lib/scoring";

export default function TimeRangeToggle({ value, onChange, testId = "time-range-toggle" }) {
  return (
    <div className="inline-flex rounded-full bg-sand-100 p-1 flex-wrap gap-0.5" data-testid={testId}>
      {TIME_RANGES.map((r) => (
        <button
          key={r.id}
          onClick={() => onChange(r.id)}
          className={`px-3 sm:px-4 py-1.5 rounded-full text-xs sm:text-sm font-dmsans transition ${
            value === r.id ? "bg-white text-ink-900 shadow-sm" : "text-ink-600"
          }`}
          data-testid={`${testId}-${r.id}`}
        >
          {r.label}
        </button>
      ))}
    </div>
  );
}
